/* PimziKids theme script: navigation, entrances, cart drawer (Shopify Ajax cart), product form, gallery. */
(() => {
'use strict';
const T = window.theme || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', shop: '/collections/all' }, moneyFormat: '{{amount}}' };
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const root = document.documentElement;
const rmq = matchMedia('(prefers-reduced-motion: reduce)');
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

/* ---------- money, in the shop's own format (or the shopper's market currency) ---------- */
function formatMoney(cents, format = T.moneyFormat) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const n = Number(cents) || 0;
  // Shopify Markets: when the shopper sees another currency (GBP for the UK, say), Shopify has already
  // converted the prices; this only writes them in that currency instead of the shop's own format
  if (T.currency && T.shopCurrency && T.currency !== T.shopCurrency) {
    // the shopper's own country decides the symbol, as on Shopify's pages: "£" in the UK, "$" for AUD in Australia
    const loc = (T.locale || 'en').split('-')[0] + (T.country ? '-' + T.country : '');
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: T.currency }).format(n / 100); } catch {}
    try { return new Intl.NumberFormat(T.locale || 'en', { style: 'currency', currency: T.currency }).format(n / 100); } catch {}
  }
  const fmt = (num, dec = 2, th = ',', dc = '.') => {
    const parts = (num / 100).toFixed(dec).split('.');
    return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (parts[1] ? dc + parts[1] : '');
  };
  return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
    amount: fmt(n), amount_no_decimals: fmt(n, 0), amount_with_comma_separator: fmt(n, 2, '.', ','),
    amount_no_decimals_with_comma_separator: fmt(n, 0, '.', ','), amount_with_apostrophe_separator: fmt(n, 2, "'", '.'),
    amount_with_space_separator: fmt(n, 2, ' ', ',')
  }[k] ?? fmt(n)));
}

// whole amounts without the cents ("$20" rather than "$20.00"), like Shopify's money_without_trailing_zeros
const roundMoney = cents => formatMoney(cents).replace(/[.,]00(?=\D*$)/, '');

/* ---------- amounts set in the shop's currency, for shoppers paying in another one ---------- */
// Shopify Markets: a shopper in the UK or Australia pays in pounds or Australian dollars. The board's price is already
// converted by Shopify, but the bundle savings and the free-shipping minimum are set in the shop's currency (Theme settings),
// so they are converted here with the same rate Shopify uses for this shopper (Shopify.currency.rate), as Shopify does
// for the automatic discounts and the shipping rate's minimum. FX = 0 means the rate is unknown: those notes stay hidden.
const SAME_CURRENCY = !T.currency || !T.shopCurrency || T.currency === T.shopCurrency;
const FX = SAME_CURRENCY ? 1 : (+((window.Shopify || {}).currency || {}).rate || 0);
const toLocal = base => Math.round((+base || 0) * FX);
// text from the editor with live offer words ([save_2], [price_3], [free_shipping]...): in another currency the page
// leaves them as placeholders (snippet offer-text) and they are filled in here
function fxFill(scope = document) {
  if (SAME_CURRENCY || !FX) return;
  $$('[data-fx]', scope).forEach(el => {
    const kind = el.dataset.fx, unit = +el.dataset.unit || 0, n = +el.dataset.n || 1;
    const save = toLocal(el.dataset.save), base = toLocal(el.dataset.base);
    if (kind === 'total') el.textContent = formatMoney(Math.max(0, unit * n - save));
    else if (kind === 'each') el.textContent = formatMoney(Math.round(Math.max(0, unit * n - save) / n));
    else if (kind === 'save') el.textContent = roundMoney(save);
    else if (kind === 'free') el.textContent = roundMoney(base);
    else if (kind === 'single') el.hidden = !(base > 0 && unit >= base);
  });
}
fxFill();

/* ---------- navigation ---------- */
const nav = $('.nav');
const heroEl = () => $('[data-hero]');
let navSolid = null, navRaf = null;
function navFrame() {
  if (!nav) return;
  const h = heroEl();
  const solid = !h || scrollY > h.offsetHeight - 90;
  if (solid !== navSolid) { nav.classList.toggle('solid', solid); navSolid = solid; }
}
addEventListener('scroll', () => { if (navRaf === null) navRaf = requestAnimationFrame(() => { navRaf = null; navFrame(); }); }, { passive: true });
addEventListener('resize', navFrame);
navFrame();

const menuBtn = $('.menu-btn'), menu = $('#menu');
function setMenu(open) {
  if (!menu || !menuBtn) return;
  root.classList.toggle('menu-open', open);
  menuBtn.setAttribute('aria-expanded', String(open));
  menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  menu.inert = !open;
  if (open) { const f = $('a', menu); f && f.focus(); }
}
if (menu) { menu.inert = true; $$('a', menu).forEach((a, i) => a.style.setProperty('--i', i)); }
menuBtn && menuBtn.addEventListener('click', () => setMenu(!root.classList.contains('menu-open')));
menu && menu.addEventListener('click', e => { if (e.target.closest('a')) setMenu(false); });
addEventListener('keydown', e => { if (e.key === 'Escape' && root.classList.contains('menu-open')) { setMenu(false); menuBtn.focus(); } });
matchMedia('(min-width: 861px)').addEventListener('change', e => { if (e.matches) setMenu(false); });

/* ---------- entrances and living elements ---------- */
const revealIO = new IntersectionObserver(es => es.forEach(e => {
  if (!e.isIntersecting) return;
  const el = e.target;
  el.classList.add('in');
  revealIO.unobserve(el);
  const rs = $$('.r', el);
  const maxD = Math.max(0, ...rs.map(r => parseFloat(r.style.getPropertyValue('--d')) || 0));
  // retire the stagger so later hovers never lag (inline delays outrank stylesheet rules)
  setTimeout(() => { el.classList.add('settled'); rs.forEach(r => r.style.removeProperty('--d')); }, (maxD + 1.2) * 1000);
}), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
const aliveIO = new IntersectionObserver(es => es.forEach(e => e.target.classList.toggle('alive', e.isIntersecting)), { rootMargin: '10% 0px' });
function watch(scope = document) {
  $$('.reveal', scope).forEach(el => {
    if (el.dataset.watched) return;
    el.dataset.watched = '1';
    if (T.designMode) { el.classList.add('in', 'settled'); return; }
    $$('.r', el).forEach((r, i) => r.style.setProperty('--d', (i * 0.09).toFixed(2) + 's'));
    revealIO.observe(el);
  });
  $$('[data-alive]', scope).forEach(el => { if (!el.dataset.aliveWatched) { el.dataset.aliveWatched = '1'; aliveIO.observe(el); } });
}
watch();
document.addEventListener('visibilitychange', () => document.body.classList.toggle('paused', document.hidden));

/* ---------- cart (Shopify Ajax cart, real Shopify checkout) ---------- */
// Every cart answer gets a number, and only a newer answer may replace the cart on screen. Without this, the page's first
// look at the cart (still on its way on a slow phone) could land after a quick first Add to cart and show an empty cart.
// Cart changes run one after another (never dropped), and every request skips the browser's cache.
let cart = null, cartError = '', cartSeq = 0, cartShown = 0, cartQueue = Promise.resolve(), cartPending = 0;
const json = async (url, opts = {}) => {
  const res = await fetch(url, { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, cache: 'no-store', ...opts });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) { const err = new Error(data.description || data.message || 'cart ' + res.status); err.user = !!data.description; throw err; }
  return data;
};
const showCart = (seq, data) => { if (seq > cartShown) { cartShown = seq; cart = data; } };
async function readCart() {
  const seq = ++cartSeq;
  const data = await json(`${T.routes.cart}.js?_=${Date.now()}`);
  showCart(seq, data);
  return data;
}
const loadCart = async () => { try { await readCart(); } catch {} renderCart(); };
function cartCall(fn) {
  const run = async () => {
    cartPending++; cartError = ''; setBusy(true);
    cartShown = ++cartSeq;   // anything read before this change is out of date now
    try { return await fn(); }
    catch (e) { cartError = e.user ? e.message : "That didn't work. Please check your connection and try again."; throw e; }
    finally { cartPending--; if (!cartPending) setBusy(false); renderCart(); }
  };
  const p = cartQueue.then(run, run);
  cartQueue = p.catch(() => {});
  return p;
}
// extra: more lines added in the same request (e.g. the ticked add-on), so they land together
async function addToCart(id, quantity = 1, extra = []) {
  await cartCall(async () => {
    const added = await json(T.routes.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(id), quantity }, ...extra] }) });
    // show the cart only once it holds what was just added (Shopify answers with the line and its new quantity)
    const line = added && added.items && added.items[0];
    for (let tries = 0; tries < 3; tries++) {
      const c = await readCart();
      if (!line || c.items.some(l => l.key === line.key && l.quantity >= line.quantity)) break;
      await new Promise(r => setTimeout(r, 400));
    }
  });
  bumpCount();
}
const setQty = (key, quantity) => cartCall(async () => {
  const seq = ++cartSeq;
  showCart(seq, await json(T.routes.cartChange + '.js', { method: 'POST', body: JSON.stringify({ id: key, quantity }) }));
});
// coming back with the Back button (e.g. from checkout) shows the page from memory: refresh the cart
addEventListener('pageshow', e => { if (e.persisted) loadCart(); });

const BAG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1.2 11.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>';
const CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.6l4.4 4.4L19 7.4"/></svg>';
const TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.8 7h10.7v9.2H2.8z"/><path d="M13.5 10.2h4.1l3.1 3.2v2.8h-7.2z"/><circle cx="6.8" cy="17.4" r="1.9"/><circle cx="17" cy="17.4" r="1.9"/></svg>';
const ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
const STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/></svg>';
const RETURN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 14L4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg>';
const LOCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="2.6"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg>';
const C = T.cart || {};   // the drawer's texts, from Theme settings > Cart drawer (snippet cart-drawer-settings)
const sized = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';
// what a line would cost without savings: its compare-at price (C.was, only while Theme settings > Cart drawer >
// "Show crossed-out compare-at prices" is ticked) when that is higher, otherwise its price before Shopify's discounts
const lineRef = l => { const w = +(C.was || {})[l.variant_id] || 0; return w > l.original_price ? w * l.quantity : l.original_line_price; };
function linesHTML() {
  if (!cart) return '<div class="cart-empty"><p>Loading your cart...</p></div>';
  if (!cart.items.length) return `<div class="cart-empty">${BAG}<p>Your cart is empty.</p><a class="btn btn-ghost btn-sm" href="${esc(T.routes.shop)}">Go to the shop</a></div>`;
  return cart.items.map(l => {
    const variant = l.variant_title && !/default title/i.test(l.variant_title) ? `<span class="v">${esc(l.variant_title)}</span>` : '';
    const img = l.image ? `<img src="${esc(sized(l.image, 180))}" alt="${esc(l.product_title)}" width="76" height="76" loading="lazy">` : '<span class="ph"></span>';
    // the saving: what Shopify takes off this line (e.g. the bundle discount), plus the compare-at price when that is shown
    const ref = lineRef(l), saved = ref - l.final_line_price;
    const was = saved > 0 ? `<s class="lp-was"><span class="sr">Was </span>${formatMoney(ref)}</s>` : '';
    return `<div class="cart-line">${img}<div><a class="t" href="${esc(l.url)}">${esc(l.product_title)}</a><br>${variant}
      <div class="stepper" role="group" aria-label="Quantity of ${esc(l.product_title)}"><button type="button" data-line="${esc(l.key)}" data-to="${l.quantity - 1}" aria-label="One less">&minus;</button><span aria-live="polite">${l.quantity}</span><button type="button" data-line="${esc(l.key)}" data-to="${l.quantity + 1}" aria-label="One more">+</button></div></div>
      <div><div class="lp">${was}<span class="lp-now">${formatMoney(l.final_line_price)}</span></div>${saved > 0 ? `<span class="lp-save">You save ${esc(roundMoney(saved))}</span>` : ''}<button type="button" class="rm" data-line="${esc(l.key)}" data-to="0">Remove</button></div></div>`;
  }).join('');
}
// free standard shipping, from the minimum in Theme settings > Shipping (0 = unknown here, e.g. another currency or a
// country whose zone has its own rule); "or more", like Shopify's "free $35.00 and up". It's measured on the cart total
// after discounts, like Shopify's price-based shipping rates.
const FREE_FROM = SAME_CURRENCY ? +T.freeShippingFrom || 0 : toLocal(T.freeShippingFromBase);
// What the products cost after every discount, without shipping. Built from the lines on purpose: Shopify's answer to a
// cart change can count an estimated shipping charge in total_price, while /cart.js doesn't.
const cartLevelOff = c => (c.cart_level_discount_applications || []).reduce((sum, d) => sum + (d.total_allocated_amount || 0), 0);
const goodsTotal = c => Math.max(0, c.items_subtotal_price - cartLevelOff(c));
const STEPS = C.steps || ['Cart', 'Free shipping', 'Checkout'];
// "Cart > Free shipping > Checkout": built once, then only updated, so the bar can glide and screen readers hear the
// message change. Done steps get a check and a solid line, upcoming ones a dashed line. Checkout is never shown as done:
// that happens on Shopify's checkout. Where the $35 minimum doesn't apply (another currency, or a country with its own
// rule), the free-shipping step stays open and the message says shipping is worked out at checkout.
function renderSteps(box) {
  if (!box) return;
  const on = !!(cart && cart.items.length);
  box.hidden = !on;
  if (!on) return;
  if (!box.firstElementChild) {
    box.innerHTML = `<ol class="steps" aria-label="Your progress">
      <li class="st st-1 done"><span class="st-dot">${CHECK}</span><span class="st-lbl">${esc(STEPS[0])}</span><span class="sr" data-st-sr>: done</span></li>
      <li class="st st-2"><span class="st-dot">${TRUCK}<i class="st-ok">${CHECK}</i></span><span class="st-lbl">${esc(STEPS[1])}</span><span class="sr" data-st-sr></span></li>
      <li class="st st-3"><span class="st-dot">${ARROW}</span><span class="st-lbl">${esc(STEPS[2])}</span><span class="sr" data-st-sr>: next</span></li>
    </ol><span class="steps-line" aria-hidden="true"><i class="l1"><b></b></i><i class="l2"></i></span><p class="steps-msg" aria-live="polite"></p>`;
  }
  const total = goodsTotal(cart);
  const free = !!FREE_FROM && total >= FREE_FROM;
  box.classList.toggle('ship-unknown', !FREE_FROM);
  box.classList.toggle('is-free', free);
  box.style.setProperty('--p', FREE_FROM ? (free ? 1 : Math.max(0.04, Math.min(1, total / FREE_FROM))).toFixed(3) : '0');
  $('.st-2 [data-st-sr]', box).textContent = free ? ': unlocked' : FREE_FROM ? ': not yet' : ': worked out at checkout';
  const msg = !FREE_FROM ? esc(C.shipOther || 'Shipping is worked out at checkout.')
    : free ? esc(C.shipDone || 'Yay! You’ve unlocked free shipping 🚚')
    : esc(C.shipAway || 'You’re only [amount] away from free shipping! ✨').replace('[amount]', `<b>${esc(formatMoney(FREE_FROM - total))}</b>`);
  const p = $('.steps-msg', box);
  if (p.innerHTML !== msg) p.innerHTML = msg;
  p.classList.toggle('ok', free);
}
function trustHTML() {
  if (C.trust === false) return '';
  const items = [];
  const n = +C.ratingCount || 0;
  if (n > 0 && C.rating) items.push(`<a class="tr tr-rate" href="${esc(C.ratingUrl)}" aria-label="Rated ${esc(C.rating)} out of 5 from ${n} review${n === 1 ? '' : 's'}">${STAR}<span aria-hidden="true">${esc(Number(C.rating).toFixed(1))} · ${n.toLocaleString(T.locale || 'en')} review${n === 1 ? '' : 's'}</span></a>`);
  if (C.returns) items.push(C.returnsUrl ? `<a class="tr" href="${esc(C.returnsUrl)}">${RETURN}<span>${esc(C.returns)}</span></a>` : `<span class="tr">${RETURN}<span>${esc(C.returns)}</span></span>`);
  if (C.secure) items.push(`<span class="tr">${LOCK}<span>${esc(C.secure)}</span></span>`);
  return items.length ? `<ul class="trust-row" role="list">${items.map(i => `<li>${i}</li>`).join('')}</ul>` : '';
}
function footHTML() {
  if (!cart || !cart.items.length) return '';
  const total = goodsTotal(cart);
  // everything Shopify takes off (bundle discounts and other discounts), plus the compare-at savings when they are shown
  const saved = Math.max(0, cart.items.reduce((s, l) => s + lineRef(l), 0) - total);
  return `${saved > 0 ? `<div class="save-row"><span>You save</span><span>${formatMoney(saved)}</span></div>` : ''}<div class="sub-row"><span>Subtotal<small class="cart-note">Shipping and taxes are worked out at checkout.</small></span><span>${formatMoney(total)}</span></div>
    <form action="${esc(T.routes.cart)}" method="post" data-checkout-form><button class="btn btn-primary btn-block btn-checkout" type="submit" name="checkout" data-checkout><svg class="co-ico" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="2.6"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg><span class="co-label">${esc(C.checkout || 'Secure checkout')}</span><svg class="co-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button></form>${trustHTML()}`;
}
// The add-on reminder ("Ready to glow out of the box?"): while the cart has drawing boards but none of the add-on
// (Theme settings > Add-on: wall adapter; T.cart.addon is null where it isn't offered, e.g. outside its countries).
// With "one for each board" it offers as many as there are boards.
const PLUG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 3v5M15 3v5"/><path d="M6.5 8h11v3.2a5.5 5.5 0 0 1-11 0z"/><path d="M12 16.7V21"/></svg>';
function remindQty() {
  const A = C.addon;
  if (!A || !cart || !cart.items.length) return 0;
  const has = id => cart.items.filter(l => String(l.product_id) === String(id)).reduce((n, l) => n + l.quantity, 0);
  const boards = has(A.board);
  if (!boards || has(A.product)) return 0;
  return A.per ? boards : 1;
}
function remindHTML(n) {
  const A = C.addon, boards = cart.items.filter(l => String(l.product_id) === String(A.board)).reduce((s, l) => s + l.quantity, 0);
  const btn = (n === 1 ? A.btnOne : A.btnMany).replace('[n]', n).replace('[price]', formatMoney(A.price * n));
  const img = A.image ? `<img src="${esc(A.image)}" alt="" width="56" height="56" loading="lazy">` : `<span class="rm-ico">${PLUG}</span>`;
  return `<div class="remind">${img}<div class="rm-body"><p class="rm-t">${esc(A.title)}</p><p class="rm-x">${esc(boards === 1 ? A.textOne : A.textMany)}</p>
    <button class="btn btn-primary btn-sm rm-add" type="button" data-remind-add data-qty="${n}">${PLUG}<span>${esc(btn)}</span></button></div></div>`;
}
function renderCart() {
  const rq = remindQty();
  $$('[data-cart-view]').forEach(v => {
    renderSteps($('[data-cart-steps]', v));
    $('.cart-lines', v).innerHTML = linesHTML();
    const rm = $('[data-cart-remind]', v);
    if (rm) { rm.innerHTML = rq ? remindHTML(rq) : ''; rm.hidden = !rq; }
    const foot = $('.cart-foot', v);
    foot.innerHTML = footHTML(); foot.hidden = !foot.innerHTML;
    const err = $('.cart-err', v); err.textContent = cartError; err.hidden = !cartError;
  });
  const n = cart ? cart.item_count : 0;
  $$('[data-cart-count]').forEach(c => { c.textContent = n; c.hidden = !n; });
  $$('[data-cart-title-count]').forEach(c => { c.textContent = n ? `(${n})` : ''; c.hidden = !n; });
  $$('[data-cart-open]').forEach(b => b.setAttribute('aria-label', `Open cart, ${n} item${n === 1 ? '' : 's'}`));
  filterUpsell(rq);
}
// while the cart changes: dim the lines, tell screen readers, and pause the + / − / Remove and Add buttons so taps can't stack up
const setBusy = on => $$('[data-cart-view]').forEach(v => {
  v.classList.toggle('busy', on);
  v.setAttribute('aria-busy', String(on));
  $$('[data-line], [data-ups-add], [data-remind-add]', v).forEach(b => { b.disabled = on; });
});

/* ---------- "Complete your setup": recommendations in the cart ---------- */
// The products come from the section cart-upsell (Shopify renders them, with this shopper's prices and currency), asked for
// once. Products already in the cart are hidden, and the list is re-checked whenever the cart changes.
// "Show this product first" (Theme settings > Cart drawer): it moves to the front while the cart has one of the chosen
// products and no drawing board; otherwise the collection's own order stays.
let upsLoad = null;
function loadUpsell() {
  if (upsLoad || !$('[data-cart-ups]')) return upsLoad;
  const url = T.routes.root.replace(/\/?$/, '/') + '?sections=cart-upsell';
  upsLoad = fetch(url, { headers: { Accept: 'application/json' } })
    .then(r => (r.ok ? r.json() : {}))
    .then(d => {
      const tmp = document.createElement('div');
      tmp.innerHTML = (d && d['cart-upsell']) || '';
      const inner = tmp.firstElementChild ? tmp.firstElementChild.innerHTML : '';
      $$('[data-cart-ups]').forEach(box => { box.innerHTML = inner; box.dataset.loaded = '1'; setupCarousel(box); });
      filterUpsell();
    })
    .catch(() => { upsLoad = null; });
  return upsLoad;
}
function filterUpsell(remindOn = remindQty()) {
  const inCart = new Set(cart ? cart.items.map(l => String(l.product_id)) : []);
  if (remindOn && C.addon) inCart.add(String(C.addon.product));
  const limit = +C.upsellLimit || 8;
  const F = C.upsellFirst;
  const lead = F && F.with.some(id => inCart.has(String(id))) && !(F.board && inCart.has(String(F.board))) ? String(F.product) : '';
  $$('[data-cart-ups]').forEach(box => {
    if (!box.dataset.loaded) return;
    const track = $('[data-ups-track]', box), cards = $$('[data-ups-product]', box);
    cards.forEach((c, i) => { if (!c.dataset.upsI) c.dataset.upsI = i + 1; });
    const rank = c => (c.dataset.upsProduct === lead ? 0 : +c.dataset.upsI);
    const order = cards.slice().sort((a, b) => rank(a) - rank(b));
    if (track && order.some((c, i) => c !== cards[i])) { order.forEach(c => track.appendChild(c)); track.scrollLeft = 0; }
    let shown = 0;
    $$('[data-ups-product]', box).forEach(card => {
      const on = !inCart.has(card.dataset.upsProduct) && shown < limit;
      card.hidden = !on;
      if (on) shown++;
    });
    box.hidden = !shown || !cart || !cart.items.length;
    updateCarousel(box);
  });
}
// a swipeable row (scroll snapping) with arrows and dots; the dots follow the scroll position
function setupCarousel(box) {
  const track = $('[data-ups-track]', box);
  if (!track) return;
  const go = dir => track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: rmq.matches ? 'auto' : 'smooth' });
  const prev = $('[data-ups-prev]', box), next = $('[data-ups-next]', box);
  prev && prev.addEventListener('click', () => go(-1));
  next && next.addEventListener('click', () => go(1));
  let raf = null;
  track.addEventListener('scroll', () => { if (raf === null) raf = requestAnimationFrame(() => { raf = null; updateCarousel(box); }); }, { passive: true });
  const dots = $('[data-ups-dots]', box);
  dots && dots.addEventListener('click', e => {
    const d = e.target.closest('[data-page]');
    if (!d) return;
    const max = track.scrollWidth - track.clientWidth, step = track.clientWidth * 0.85;
    track.scrollTo({ left: Math.min(max, Math.round(+d.dataset.page * step)), behavior: rmq.matches ? 'auto' : 'smooth' });
  });
  addEventListener('resize', () => updateCarousel(box));
}
function updateCarousel(box) {
  const track = $('[data-ups-track]', box);
  if (!track || box.hidden) return;
  // one dot per arrow step (an arrow moves 85% of the visible width), the last one when the end is reached
  const max = Math.max(0, track.scrollWidth - track.clientWidth), step = Math.max(1, track.clientWidth * 0.85);
  const pages = max > 4 ? Math.ceil(max / step - 0.02) + 1 : 1;
  const at = track.scrollLeft >= max - 2 ? pages - 1 : Math.min(pages - 1, Math.round(track.scrollLeft / step));
  const prev = $('[data-ups-prev]', box), next = $('[data-ups-next]', box), dots = $('[data-ups-dots]', box);
  box.classList.toggle('one-page', pages < 2);
  if (prev) prev.disabled = track.scrollLeft <= 2;
  if (next) next.disabled = track.scrollLeft >= max - 2;
  if (dots) {
    if (dots.children.length !== (pages > 1 ? pages : 0)) dots.innerHTML = pages > 1 ? Array.from({ length: pages }, (_, i) => `<button type="button" tabindex="-1" data-page="${i}"></button>`).join('') : '';
    [...dots.children].forEach((d, i) => d.classList.toggle('on', i === at));
  }
}
// picking another variant updates that card's price, crossed-out price and badge (all written by Shopify)
document.addEventListener('change', e => {
  const s = e.target.closest('[data-ups-variant]');
  if (!s) return;
  const o = s.selectedOptions[0], card = s.closest('[data-ups-product]');
  $('[data-ups-price]', card).textContent = o.dataset.price;
  const pct = +o.dataset.pct || 0;
  $('[data-ups-save]', card).hidden = pct < 1;
  $('[data-ups-cmp-val]', card).textContent = o.dataset.cmp || '';
  $('[data-ups-off]', card).textContent = `−${pct}%`;
});
// Add: puts the chosen variant in the cart; the drawer stays open and everything (lines, totals, count, steps) updates
document.addEventListener('click', async e => {
  const b = e.target.closest('[data-ups-add]');
  if (!b || b.disabled) return;
  const box = b.closest('[data-cart-ups]'), card = b.closest('[data-ups-product]');
  const sel = $('[data-ups-variant]', card);
  const label = b.textContent;
  b.disabled = true; b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding...';
  let ok = false;
  try { await addToCart(sel ? sel.value : b.dataset.id, 1); ok = true; } catch {}
  b.removeAttribute('aria-busy'); b.textContent = label; b.disabled = false;
  // the added product leaves the list; keep the keyboard in the drawer (the next product, or the checkout button)
  if (ok && card.hidden) {
    const nextAdd = box && $$('[data-ups-product]:not([hidden]) [data-ups-add]', box)[0];
    const target = nextAdd || $('#cart-drawer [data-checkout]');
    target && target.focus({ preventScroll: true });
  }
});
document.addEventListener('click', async e => {
  const b = e.target.closest('[data-remind-add]');
  if (!b || b.disabled || !C.addon) return;
  b.disabled = true; b.setAttribute('aria-busy', 'true');
  try { await addToCart(C.addon.id, +b.dataset.qty || 1); } catch {}
  const next = $('#cart-drawer [data-checkout]');
  next && next.focus({ preventScroll: true });
});
const bumpCount = () => $$('[data-cart-count]').forEach(c => { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); });

const drawer = $('#cart-drawer');
let lastFocus = null;
function openCart() {
  if (!drawer || root.classList.contains('cart-open')) return;
  setMenu(false);
  lastFocus = document.activeElement;
  root.classList.add('cart-open');
  drawer.inert = false;
  loadUpsell();
  setTimeout(() => { drawer.focus(); filterUpsell(); }, 30);
}
function closeCart() {
  if (!root.classList.contains('cart-open')) return;
  root.classList.remove('cart-open');
  drawer.inert = true;
  if (lastFocus && lastFocus.focus) lastFocus.focus();
}
document.addEventListener('click', e => {
  const open = e.target.closest('[data-cart-open]');
  if (open) {
    const page = $('.cart-page [data-cart-view]');
    e.preventDefault();
    if (page) { page.scrollIntoView({ behavior: rmq.matches ? 'auto' : 'smooth' }); return; }
    openCart(); return;
  }
  if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
  // the cart's + / − / Remove buttons carry data-line (the line's key); data-qty belongs to the bundle cards' radios
  const q = e.target.closest('[data-cart-view] [data-line]');
  if (q && cart && !q.disabled) {
    $$('[data-cart-view] [data-line]').forEach(b => { b.disabled = true; });   // paused at once, so a quick second tap can't stack a second change
    setQty(q.dataset.line, Math.max(0, +q.dataset.to)).catch(() => {});
  }
});
addEventListener('keydown', e => {
  if (!root.classList.contains('cart-open')) return;
  if (e.key === 'Escape') { closeCart(); return; }
  if (e.key === 'Tab') {   // keep focus inside the open drawer
    const f = $$('a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), select', drawer).filter(el => el.offsetParent !== null);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
});

/* ---------- quick add (shop page, homepage) ---------- */
document.addEventListener('submit', async e => {
  const form = e.target.closest('form[data-quick-add]');
  if (!form) return;
  e.preventDefault();
  if (form.dataset.adding) return;   // a second tap while adding doesn't add twice
  form.dataset.adding = '1';
  const btn = $('button[type="submit"]', form), label = btn.textContent;
  btn.disabled = true; btn.textContent = 'Adding...'; btn.setAttribute('aria-busy', 'true');
  // added or not, the drawer opens: with the new item, or with the reason it couldn't be added
  try { await addToCart(form.elements.id.value, 1); } catch {}
  finally { delete form.dataset.adding; btn.disabled = false; btn.textContent = label; btn.removeAttribute('aria-busy'); openCart(); }
});

/* ---------- checkout: one tap is enough ---------- */
document.addEventListener('submit', e => {
  const form = e.target.closest('form[data-checkout-form]');
  if (!form) return;
  if (form.dataset.sent) { e.preventDefault(); return; }
  form.dataset.sent = '1';
  const btn = $('[data-checkout]', form);
  // the button stays enabled (Shopify needs its name to start checkout); it just says what's happening
  btn.classList.add('is-going'); btn.setAttribute('aria-busy', 'true');
  $('.co-label', btn).textContent = 'Taking you to checkout...';
});

/* ---------- product form: options, price, stock, add to cart ---------- */
function initProduct(scope = document) {
  $$('[data-product-form]', scope).forEach(box => {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    const data = JSON.parse($('script[data-product-json]', box).textContent);
    const form = $('form[data-type="add-to-cart-form"]', box);
    if (!form) return;
    const idInput = form.elements.id, qtyInput = form.elements.quantity;
    const priceEl = $('[data-price]', box), addBtn = $('[data-add]', box), msg = $('[data-msg]', box), qtyOut = $('[data-qty-out]', box);
    const addLabel = $('[data-add-label]', addBtn) || addBtn;
    const READY_LABEL = addLabel.textContent.trim() === 'Sold out' ? 'Add to cart' : addLabel.textContent.trim();
    const bundles = $$('[data-bundles] input[type="radio"]', box);
    let qty = 1;
    $$('[data-step]', box).forEach(b => b.addEventListener('click', () => { qty = Math.min(20, Math.max(1, qty + +b.dataset.step)); qtyOut.textContent = qty; qtyInput.value = qty; update(); }));
    // with bundle cards, the selected card decides the quantity sent to the cart
    const bundleQty = () => { const b = bundles.find(x => x.checked); return b ? +b.dataset.qty : 1; };
    const currentQty = () => bundles.length ? bundleQty() : qty;
    // each option group knows its position in the product's options (the size buttons sit apart from the others)
    const optSets = $$('[data-option-index]', box);
    // only the option radios count (the size guide's paper switch also sits in the size group)
    const OPT = 'input[name^="option-"]';
    const chosen = () => { const c = []; optSets.forEach(fs => { c[+fs.dataset.optionIndex] = ($(OPT + ':checked', fs) || {}).value; }); return c; };
    const match = () => { const c = chosen(); return data.variants.find(v => v.options.every((o, i) => c[i] === undefined || o === c[i])); };
    // a bundle costs the price × boards minus its fixed saving (the automatic discount in Shopify), so the cards match the cart;
    // savings and % off compare with ref per board: the confirmed compare-at ("was") price, or else today's price (% rounded down)
    function bundlePrices(price, n, save, ref) {
      const total = Math.max(0, price * n - (save || 0)), was = (ref || price) * n, shown = was - total;
      return { total, per: Math.round(total / n), save: shown, was, pct: was > 0 && shown > 0 ? Math.floor(shown * 100 / was) : 0 };
    }
    // the add-on box to tick ("Add a USB wall adapter"): never ticked at first; with "one for each board" its number
    // follows the bundle, and the bottom bar's total includes it while it's ticked
    const addon = $('[data-addon]', box), addonCheck = addon && $('[data-addon-check]', addon);
    const addonQty = () => (addon && addon.dataset.per === 'true' ? currentQty() : 1);
    const addonOn = () => !!(addonCheck && addonCheck.checked);
    const addonTotal = () => (addonOn() ? +addon.dataset.cents * addonQty() : 0);
    function syncAddon() {
      if (!addon) return;
      const n = addonQty();
      $('[data-addon-title]', addon).textContent = n === 1 ? addon.dataset.one : addon.dataset.many.replace('[n]', n);
      $('[data-addon-price]', addon).textContent = '+' + formatMoney(+addon.dataset.cents * n);
      addon.classList.toggle('on', addonOn());
    }
    const bundleGrid = $('.bundle-grid', box);
    const wasAllowed = !!bundleGrid && bundleGrid.dataset.wasAllowed === 'true';
    // photos follow the chosen size: the size's own photo from the theme first, then the variant's photo in Shopify
    const sizeSet = $('.size-opt', box), sizeIdx = sizeSet ? +sizeSet.dataset.optionIndex : -1;
    const sizePhotos = (() => { try { return JSON.parse($('script[data-size-photos]', box).textContent); } catch { return {}; } })();
    const photoFor = v => {
      const own = sizeIdx >= 0 && sizePhotos[v.options[sizeIdx]];
      if (own) return { src: own, aspect_ratio: 4 / 3, alt: `${data.title}, ${v.options[sizeIdx].split(':')[0]}` };
      return v.featured_image || null;
    };
    const gallery = $('[data-gallery]', box.closest('.pdp') || document);
    // badges and free-shipping notes follow the chosen size and bundle
    const bundleSet = $('[data-bundles]', box);
    // in cents; 0 = no free shipping (in another currency: the shop-currency minimum converted, see FX)
    const freeFrom = !bundleSet ? 0 : SAME_CURRENCY ? +bundleSet.dataset.freeFrom || 0 : toLocal(bundleSet.dataset.freeFromBase);
    // each card's saving, converted the same way for shoppers paying in another currency
    const saveOf = b => SAME_CURRENCY ? +b.dataset.save || 0 : toLocal(b.dataset.saveBase);
    // with converted savings showing on the cards, the "savings come off in your cart" note isn't needed
    if (!SAME_CURRENCY && FX) $$('[data-b-note]', box).forEach(nt => { nt.hidden = true; });
    const badgeSize = bundleSet ? bundleSet.dataset.badgeSize || '' : '';
    const shipText = $('[data-ship-text]', box);
    const fallback = $('template[data-b-fallback]', box);   // the standard photo, for sizes without their own
    // (set cards keep their own set's photo, so they are left out)
    const thumbImgs = $$('.b-thumb', box).filter(t => !t.closest('.set-card')).map(t => ({ el: t, html: fallback ? fallback.innerHTML.trim() : t.innerHTML }));
    // the add-to-cart bar on phones: its button submits this same form, so it adds the same variant and quantity
    // (getAttribute: the form's "id" field hides form.id)
    const bar = $$('[data-sticky-buy]').find(b => b.dataset.stickyBuy === form.getAttribute('id'));
    const sb = bar && { size: $('[data-sb-size]', bar), dot: $('.sb-dot', bar), qty: $('[data-sb-qty]', bar), total: $('[data-sb-total]', bar), save: $('[data-sb-save]', bar), btn: $('[data-sb-add]', bar), label: $('[data-sb-label]', bar), msg: $('[data-sb-msg]', bar) };
    // the bar steps aside while the main Add to cart button is on screen, so it never covers the bundle cards or doubles up
    if (bar && 'IntersectionObserver' in window) new IntersectionObserver(([e]) => bar.classList.toggle('sb-off', e.isIntersecting)).observe(addBtn);
    let sbMsgTimer = null;
    function syncBar(v, sel) {
      if (!sb) return;
      sb.btn.disabled = addBtn.disabled;
      sb.label.textContent = addLabel.textContent;
      if (!v) return;
      const n = currentQty(), size = bar.dataset.sizeLabel || (sizeIdx >= 0 ? v.options[sizeIdx].split(':')[0].trim() : '');
      if (!bar.dataset.sizeLabel) sb.size.textContent = size;
      sb.size.hidden = sb.dot.hidden = !size;
      sb.qty.textContent = `${n} ${n === 1 ? bar.dataset.one : bar.dataset.many}`;
      // with the add-on ticked, the bar says "2 boards + 2 adapters" (instead of the size) and its total includes them
      if (addonOn()) {
        const k = addonQty();
        sb.qty.textContent += ` + ${k} ${k === 1 ? addon.dataset.unitOne : addon.dataset.unitMany}`;
        sb.size.hidden = sb.dot.hidden = true;
      }
      sb.total.textContent = formatMoney(sel.total + addonTotal());
      sb.save.hidden = !(sel.save > 0);
      sb.save.textContent = `Save ${roundMoney(sel.save)}`;
    }
    function barMessage(text) {
      if (!sb) return;
      clearTimeout(sbMsgTimer);
      sb.msg.textContent = text;
      sb.msg.hidden = !text;
      if (text) sbMsgTimer = setTimeout(() => { sb.msg.hidden = true; }, 6000);
    }
    let vMain = null;
    function showVariantPhoto(v, swapMain) {
      const img = v && photoFor(v);
      thumbImgs.forEach(t => {
        if (img) t.el.innerHTML = `<img src="${sized(img.src, 240)}" alt="" width="240" height="${Math.round(240 / (img.aspect_ratio || 1))}" decoding="async">`;
        else if (t.el.innerHTML !== t.html) t.el.innerHTML = t.html;
      });
      if (!gallery || !swapMain) return;
      const main = $('.main', gallery);
      if (img) {
        if (!vMain) { vMain = document.createElement('img'); vMain.setAttribute('decoding', 'async'); main.prepend(vMain); }
        vMain.src = sized(img.src, 1600);
        vMain.alt = img.alt || data.title;
        $$('img, svg', main).forEach(x => x.classList.toggle('on', x === vMain));
        $$('.thumb', gallery).forEach(x => x.setAttribute('aria-pressed', 'false'));
      } else if (vMain && vMain.classList.contains('on')) {
        vMain.classList.remove('on');
        const first = $$('img, svg', main).find(x => x !== vMain);
        if (first) first.classList.add('on');
        const t0 = $('.thumb', gallery); if (t0) t0.setAttribute('aria-pressed', 'true');
      }
    }
    function update() {
      const v = match(), c = chosen();
      optSets.forEach(fs => { const i = +fs.dataset.optionIndex; $$(OPT, fs).forEach(inp => {
        const test = c.slice(); test[i] = inp.value;
        const ok = data.variants.some(x => x.available && x.options.every((o, j) => test[j] === undefined || o === test[j]));
        inp.closest('.pill, .size').classList.toggle('na', !ok);
      }); });
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Not available'; syncBar(null); return; }
      idInput.value = v.id;
      qtyInput.value = currentQty();
      if (priceEl) priceEl.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? `<s>${formatMoney(v.compare_at_price)}</s>` : '');
      const ref = wasAllowed && v.compare_at_price > v.price ? v.compare_at_price : v.price;
      const prices = bundles.map(b => bundlePrices(v.price, +b.dataset.qty, saveOf(b), ref));
      const sel = bundles.length ? prices[Math.max(0, bundles.findIndex(x => x.checked))] : bundlePrices(v.price, currentQty(), 0, ref);
      const sizeOk = !badgeSize || (sizeIdx >= 0 && v.options[sizeIdx].toLowerCase().includes(badgeSize));
      bundles.forEach((b, i) => {
        const card = b.closest('.bundle'), p = prices[i];
        const ship = $('[data-b-ship]', card);
        if (ship) ship.hidden = !(freeFrom && p.total >= freeFrom);
        const badge = $('[data-badge]', card);
        if (badge) badge.hidden = !(sizeOk && (badge.dataset.badge !== 'best' || prices.every((q, j) => j === i || p.save > q.save)));
        const perEl = $('[data-b-per]', card);
        $('[data-b-total]', card).textContent = formatMoney(p.total);
        perEl.textContent = `${formatMoney(p.per)}/${perEl.dataset.unit || ''}`;
        const s = $('[data-b-save]', card);
        if (s) { s.hidden = p.save <= 0; s.textContent = `Save ${roundMoney(p.save)}`; }
        const was = $('[data-b-was]', card);
        if (was) { was.hidden = !(ref > v.price); was.innerHTML = `<span class="sr">Was </span>${esc(formatMoney(p.was))}`; }
        const pc = $('[data-b-pct]', card);
        if (pc) { pc.hidden = p.pct <= 0; pc.textContent = `${p.pct}% OFF`; }
      });
      // "Free shipping on every bundle" (one line under the cards) shows while every bundle reaches the minimum
      const shipAll = $('[data-b-ship-all]', box);
      if (shipAll) shipAll.hidden = !(freeFrom && prices.length && prices.every(p => p.total >= freeFrom));
      if (shipText) shipText.textContent = freeFrom && sel.total >= freeFrom ? shipText.dataset.free : shipText.dataset.normal;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? READY_LABEL : 'Sold out';
      syncAddon();
      syncBar(v, sel);
      // the first photo stays as it is on arrival; picking a size then shows that size's photo
      if (v.id !== shownVariant) { const first = shownVariant === null; shownVariant = v.id; if (data.variants.length > 1) showVariantPhoto(v, !first); }
      if (data.variants.length > 1) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    }
    let shownVariant = null;
    box.addEventListener('change', e => { if (e.target.matches(OPT) || e.target.closest('[data-bundles]') || e.target.matches('[data-addon-check]')) update(); });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const v = match(); if (!v || !v.available) return;
      if (form.dataset.adding) return;   // a second tap (main button or the bar) while adding doesn't add twice
      form.dataset.adding = '1';
      addBtn.disabled = true; addBtn.setAttribute('aria-busy', 'true'); addLabel.textContent = 'Adding...'; msg.textContent = ''; barMessage('');
      syncBar(null);
      const extra = addonOn() ? [{ id: +addon.dataset.variant, quantity: addonQty() }] : [];
      try { await addToCart(v.id, currentQty(), extra); openCart(); }
      catch {
        msg.textContent = cartError || "That didn't work. Please try again.";
        if (sb && e.submitter === sb.btn) barMessage(msg.textContent);
      }
      finally { delete form.dataset.adding; addBtn.removeAttribute('aria-busy'); update(); }
    });
    update();
  });
  $$('[data-gallery]', scope).forEach(g => {
    if (g.dataset.ready) return;
    g.dataset.ready = '1';
    const main = $('.main', g);
    const imgs = $$('.main > img, .main > svg', g), thumbs = $$('.thumb', g);
    const dots = $$('.px-dots i', g), status = $('[data-gal-status]', g);
    const strip = $('[data-thumbs]', g), stripBtns = $$('[data-thumbs-step]', g);
    let at = 0;
    function show(i, announce) {
      if (!imgs.length) return;
      at = (i + imgs.length) % imgs.length;
      $$('.main > img, .main > svg', g).forEach(im => { if (!imgs.includes(im)) im.classList.remove('on'); });   // a size's own photo steps aside
      imgs.forEach((im, j) => im.classList.toggle('on', at === j));
      thumbs.forEach((x, j) => x.setAttribute('aria-pressed', String(at === j)));
      dots.forEach((d, j) => d.classList.toggle('on', at === j));
      if (status && announce) status.textContent = `Photo ${at + 1} of ${imgs.length}`;
      // keep the chosen thumbnail in view in the strip under the photo
      const t = thumbs[at];
      if (strip && t && strip.scrollWidth > strip.clientWidth) {
        const l = t.offsetLeft - strip.offsetLeft, r = l + t.offsetWidth;
        if (l < strip.scrollLeft || r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: l - (strip.clientWidth - t.offsetWidth) / 2, behavior: rmq.matches ? 'auto' : 'smooth' });
      }
    }
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    $$('[data-gal-step]', g).forEach(b => b.addEventListener('click', () => show(at + +b.dataset.galStep, true)));
    main.addEventListener('keydown', e => {
      if (e.target !== main || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      e.preventDefault();
      show(at + (e.key === 'ArrowRight' ? 1 : -1), true);
    });
    // a sideways swipe on the photo turns to the next or previous one; an up-and-down swipe still scrolls the page
    let sx = null, sy = 0;
    main.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' && !e.target.closest('button')) { sx = e.clientX; sy = e.clientY; } }, { passive: true });
    main.addEventListener('pointerup', e => {
      if (sx === null) return;
      const dx = e.clientX - sx, dy = e.clientY - sy;
      sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) show(at + (dx < 0 ? 1 : -1), true);
    });
    main.addEventListener('pointercancel', () => { sx = null; });
    // the thumbnail strip: arrows show only when the thumbnails don't all fit
    if (strip) {
      const stripNav = () => {
        const max = strip.scrollWidth - strip.clientWidth;
        stripBtns.forEach(b => {
          b.hidden = max <= 4;
          b.disabled = +b.dataset.thumbsStep < 0 ? strip.scrollLeft <= 4 : strip.scrollLeft >= max - 4;
        });
      };
      stripBtns.forEach(b => b.addEventListener('click', () => strip.scrollBy({ left: +b.dataset.thumbsStep * strip.clientWidth * 0.8, behavior: rmq.matches ? 'auto' : 'smooth' })));
      strip.addEventListener('scroll', () => requestAnimationFrame(stripNav), { passive: true });
      addEventListener('resize', stripNav);
      stripNav();
    }
  });
  // the one-button bar at the bottom: it shows once the main Add to cart button has scrolled out of view above,
  // and takes the shopper back to the bundle cards
  $$('[data-sticky-go]', scope).forEach(bar => {
    if (bar.dataset.ready) return;
    bar.dataset.ready = '1';
    const form = document.getElementById(bar.dataset.stickyGo);
    const btn = form && $('[data-add]', form);
    if (!btn || !('IntersectionObserver' in window)) { bar.classList.add('on'); return; }
    new IntersectionObserver(([e]) => bar.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(btn);
  });
}
// links to the bundle cards (#choose): scroll there and put the keyboard on the chosen card
document.addEventListener('click', e => {
  const a = e.target.closest('a[href="#choose"]');
  const panel = document.getElementById('choose');
  if (!a || !panel) return;
  e.preventDefault();
  panel.scrollIntoView({ behavior: rmq.matches ? 'auto' : 'smooth', block: 'start' });
  const r = $('[data-bundles] input:checked', panel) || $('[data-bundles] input', panel);
  if (r) r.focus({ preventScroll: true });
});
initProduct();
// phones: the add-to-cart bar steps aside while the on-screen keyboard is up (a field anywhere on the page has focus)
const typing = el => !!(el && el.matches && el.matches('textarea, input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]):not([type=hidden]):not([type=range])'));
document.addEventListener('focusin', e => root.classList.toggle('kb-open', typing(e.target)));
document.addEventListener('focusout', () => root.classList.remove('kb-open'));

/* ---------- question cards: smooth open and close where CSS can't animate height ---------- */
if (!(window.CSS && CSS.supports('interpolate-size', 'allow-keywords'))) {
  document.addEventListener('click', e => {
    const s = e.target.closest('details.qa-card > summary, details.sg > summary');
    if (!s || rmq.matches) return;
    const d = s.parentElement, body = $('.qa-a, .sg-body', d);
    if (!body) return;
    e.preventDefault();
    if (d.dataset.anim) return;
    d.dataset.anim = '1';
    const ease = { duration: 380, easing: 'cubic-bezier(.45,0,.2,1)' };
    const done = () => delete d.dataset.anim;
    if (!d.open) {
      d.open = true;
      body.animate([{ height: '0px', opacity: 0 }, { height: body.offsetHeight + 'px', opacity: 1 }], ease).onfinish = done;
    } else {
      // hold the closed state until the card is shut, so nothing flashes open for a frame
      const a = body.animate([{ height: body.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { ...ease, fill: 'forwards' });
      a.onfinish = () => { d.open = false; a.cancel(); done(); };
    }
  });
}

/* ---------- country / currency: switch as soon as one is picked ---------- */
$$('[data-loc-go]').forEach(b => { b.hidden = true; });
document.addEventListener('change', e => { if (e.target.matches('[data-loc-select]')) e.target.form.submit(); });

/* ---------- coming soon: the button opens the email signup ---------- */
document.addEventListener('toggle', e => {
  const d = e.target;
  if (!d.matches || !d.matches('[data-notify]') || !d.open) return;
  const input = $('input[type="email"]', d);
  if (input) input.focus({ preventScroll: true });
}, true);
function openNotifyFromLink() {
  if (location.hash !== '#notify') return;
  const d = $('[data-notify]');
  if (!d) return;
  d.open = true;
  d.scrollIntoView({ behavior: 'auto', block: 'center' });
}
openNotifyFromLink();
window.addEventListener('hashchange', openNotifyFromLink);
// after a signup the page reloads with the result showing; bring it into view
$$('[data-notify][open]').forEach(d => {
  d.scrollIntoView({ behavior: 'auto', block: 'center' });
  const bad = $('[aria-invalid="true"]', d);
  if (bad) bad.focus({ preventScroll: true });
});

/* ---------- contact page: the form button lands the cursor in the first field ---------- */
document.addEventListener('click', e => {
  const a = e.target.closest('[data-to-form]');
  if (!a) return;
  const form = $('#contact-form');
  if (!form) return;
  e.preventDefault();
  form.scrollIntoView({ behavior: rmq.matches ? 'auto' : 'smooth', block: 'start' });
  const first = $('input:not([type=hidden]), textarea', form);
  if (first) setTimeout(() => first.focus({ preventScroll: true }), rmq.matches ? 0 : 500);
  history.replaceState(null, '', '#contact-form');
});

/* ---------- theme editor ---------- */
document.addEventListener('shopify:section:load', e => { watch(e.target); initProduct(e.target); navFrame(); });

if (drawer) {
  drawer.inert = true; renderCart();
  // with something already in the cart, fetch the recommendations once the page is idle, so they're ready when it opens
  const whenIdle = fn => (window.requestIdleCallback ? requestIdleCallback(fn, { timeout: 3000 }) : setTimeout(fn, 1500));
  loadCart().then(() => { if (cart && cart.items.length) whenIdle(() => loadUpsell()); });
}
})();
